export function getSharePageUrl() {
  if (typeof window === "undefined") return "";
  return window.location.href;
}

export function buildSocialShareHref(network, { url, title, text }) {
  const pageUrl = encodeURIComponent(url);
  const shareTitle = encodeURIComponent(title || "");
  const shareText = encodeURIComponent(text || title || "");

  switch (network) {
    case "whatsapp":
      return `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareTitle}`;
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`;
    case "email":
      return `mailto:?subject=${shareTitle}&body=${shareText}%0A%0A${pageUrl}`;
    default:
      return url;
  }
}

export const SOCIAL_SHARE_NETWORKS = [
  { id: "whatsapp", label: "WhatsApp" },
  { id: "facebook", label: "Facebook" },
  { id: "twitter", label: "X" },
  { id: "linkedin", label: "LinkedIn" },
];
